import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  state: {
    user: null,
    fireToken: null,
    completed_signup: false,
    profile_loaded: false,
  },
  mutations: {
    updateUser(state, user) {
      console.log('updateUser was called')
      state.user = user
    },
    SET_TOKEN(state, token) {
      state.fireToken = token
    },
    updateCompletedSignup(state, status){
      state.completed_signup = status
    },
    setProfileLoaded(state, status){
      state.profile_loaded = status;
    },
  },
  actions: {},
  getters: {
    user: state => state.user,
    token: state => state.fireToken,
    completed_signup: state => state.completed_signup,
    profile_loaded: state => state.profile_loaded,
  },
}
